/**
 * PostHog funnel tracking — quiz landing, quiz questions (DOM fallback), taste profile, Dragon Slayer, Father's Day,
 * Labor Day offer, homepage rework.
 */
(function () {
  'use strict';

  function ph() {
    return window.whiskyPosthog;
  }

  function track(event, properties) {
    var w = ph();
    if (!w) return;
    w.capture(event, w.funnelContext(properties));
  }

  function templateSuffix() {
    if (!window._template) return '';
    return window._template.suffix || window._template.name || '';
  }

  function isFunnelPage() {
    var s = templateSuffix();
    if (!s) return false;
    return (
      s.indexOf('quiz') !== -1 ||
      s.indexOf('taste-profile') !== -1 ||
      s.indexOf('dragon-slayer') !== -1 ||
      s.indexOf('father-day') !== -1
    );
  }

  function initQuizNavSource() {
    var w = ph();
    if (!w) return;
    var source = w.getQuizNavSource();
    if (source) w.register({ quiz_nav_source: source });
  }

  function initFunnelPageView() {
    if (!isFunnelPage()) return;
    track('funnel_page_viewed', {
      funnel_page: templateSuffix(),
      funnel_step: funnelStepFromSuffix(templateSuffix())
    });
  }

  function funnelStepFromSuffix(suffix) {
    if (suffix === 'quiz-landing' || suffix === 'quiz-landing-v2' || suffix === 'quiz-landing-personalize' || suffix === 'quiz-landing-hero') return 'landing';
    if (suffix === 'quiz-questions') return 'quiz';
    if (suffix === 'taste-profile' || suffix === 'taste-profile-v2') return 'taste_profile';
    if (suffix === 'dragon-slayer') return 'dragon_slayer';
    if (suffix && suffix.indexOf('father-day') !== -1) return 'father_day';
    return suffix;
  }

  function initQuizLandingMilestoneUser() {
    var s = templateSuffix();
    if (s !== 'quiz-landing' && s !== 'quiz-landing-v2' && s !== 'quiz-landing-personalize' && s !== 'quiz-landing-hero') return;

    function apply() {
      var w = ph();
      if (w && typeof w.setMilestoneUserOnce === 'function') {
        w.setMilestoneUserOnce();
      } else if (w && typeof w.setFirstSeenAtOnce === 'function') {
        w.setFirstSeenAtOnce();
      }
    }

    var w = ph();
    if (w && typeof w.isSdkReady === 'function' && w.isSdkReady()) {
      apply();
      return;
    }
    window.addEventListener('whisky-posthog-ready', apply, { once: true });
  }

  function initQuizLandingClicks() {
    var s = templateSuffix();
    if (s !== 'quiz-landing' && s !== 'quiz-landing-v2' && s !== 'quiz-landing-personalize' && s !== 'quiz-landing-hero') return;

    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="quiz-questions"]');
        if (!link) return;
        track('quiz_landing_cta_clicked', {
          cta_href: link.getAttribute('href'),
          cta_text: (link.textContent || '').trim().slice(0, 120),
          cta_location: link.closest('section') ? link.closest('section').id || link.className : link.className
        });
      },
      true
    );
  }

  function initTasteProfileObservers() {
    var suffix = templateSuffix();
    if (suffix !== 'taste-profile' && suffix !== 'taste-profile-v2') return;

    var pageRoot = document.querySelector('.taste-profile-page');
    if (!pageRoot) return;

    var profileReported = false;
    var loadingClearedReported = false;

    function reportProfileShown() {
      if (profileReported) return;
      var result = pageRoot.getAttribute('data-taste-profile');
      if (!result) return;
      profileReported = true;
      track('taste_profile_revealed', {
        taste_profile: result,
        selected_tier: pageRoot.getAttribute('data-selected-tier') || null
      });
      var w = ph();
      if (w) {
        w.register({
          taste_profile_result: result,
          taste_profile_selected_tier: pageRoot.getAttribute('data-selected-tier') || ''
        });
      }
    }

    function reportLoadingComplete() {
      if (loadingClearedReported) return;
      if (pageRoot.classList.contains('taste-profile-page--loading')) return;
      loadingClearedReported = true;
      track('taste_profile_content_ready', {
        taste_profile: pageRoot.getAttribute('data-taste-profile') || null
      });
      reportProfileShown();
    }

    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          if (m.attributeName === 'data-taste-profile') reportProfileShown();
          if (m.attributeName === 'class') reportLoadingComplete();
        });
      }).observe(pageRoot, {
        attributes: true,
        attributeFilter: ['data-taste-profile', 'data-selected-tier', 'class']
      });
    }

    // The milestone cards render their rewards from the shop metafield the backend writes
    // (Settings > Milestone rewards). An empty metafield means the cards shipped without a
    // rewards block, which is a data problem, not a visitor one; report it once per view.
    var rewardsGrid = document.querySelector('[data-milestone-rewards]');
    if (rewardsGrid && rewardsGrid.getAttribute('data-milestone-rewards') === 'missing') {
      track('milestone_rewards_missing', {
        taste_profile: pageRoot.getAttribute('data-taste-profile') || null
      });
    }

    document.addEventListener('tp:tier-request', function (e) {
      var tier = e.detail && e.detail.tier;
      if (!tier) return;
      track('taste_profile_tier_selected', {
        tier: tier,
        taste_profile: pageRoot.getAttribute('data-taste-profile') || null
      });
    });

    var tierReported = {};
    document.addEventListener(
      'click',
      function (e) {
        var card = e.target.closest('.tpf-card[data-tier]');
        if (card) {
          track('taste_profile_tier_card_clicked', {
            tier: card.getAttribute('data-tier'),
            source: 'card'
          });
          return;
        }
        var tab = e.target.closest('.tp-tier-mobile-switcher__item[data-tier]');
        if (tab) {
          track('taste_profile_tier_tab_clicked', {
            tier: tab.getAttribute('data-tier'),
            source: 'mobile_tab'
          });
        }
      },
      true
    );

    setTimeout(reportLoadingComplete, 500);
    setTimeout(reportProfileShown, 1500);
  }

  /**
   * Two-page taste profile close (snippets/taste-profile-close.liquid, PostHog flag
   * taste-profile-close). The snippet runs from the first paint, long before PostHog
   * boots, so it records what happened in window.__TP_CLOSE__.queue and announces each
   * entry as `tp-close:event`; this sends the queue once, in order, whenever it grows and
   * the wrapper exists (the funnel script can arrive before analytics-posthog-core.js).
   * Every event carries the arm, where it came from (`qa` for forced QA and demo views) and
   * the moment it happened (`occurred_at`): entries sent late would otherwise all carry the
   * boot time.
   */
  function initTasteProfileClose() {
    var state = window.__TP_CLOSE__;
    if (!state || !Array.isArray(state.queue)) return;
    var names = {
      arm: 'taste_profile_close_arm_assigned',
      view: 'taste_profile_close_viewed',
      cta: 'taste_profile_close_cta_clicked',
      back: 'taste_profile_close_back_clicked'
    };
    var sent = 0;

    function drain() {
      if (!ph()) return;
      while (sent < state.queue.length) {
        var entry = state.queue[sent];
        sent += 1;
        var name = entry && names[entry.type];
        if (!name) continue;
        var props = {
          taste_profile_close_arm: state.arm,
          taste_profile_close_source: state.source,
          occurred_at: new Date(entry.at).toISOString()
        };
        var detail = entry.detail || {};
        Object.keys(detail).forEach(function (key) {
          props[key] = detail[key];
        });
        track(name, props);
      }
    }

    drain();
    document.addEventListener('tp-close:event', drain);
    window.addEventListener('whisky-posthog-ready', drain);
  }

  function initDragonSlayerAndFatherDay() {
    var suffix = templateSuffix();
    var isDs = suffix === 'dragon-slayer';
    var isFd = suffix && suffix.indexOf('father-day') !== -1;
    if (!isDs && !isFd) return;

    document.addEventListener(
      'click',
      function (e) {
        var cta = e.target.closest('[data-dsl-explorer-checkout]');
        if (!cta) return;
        track(isDs ? 'dragon_slayer_checkout_cta_clicked' : 'father_day_checkout_cta_clicked', {
          tier_key: cta.getAttribute('data-tier-key') || cta.getAttribute('data-tier') || null,
          cta_text: (cta.textContent || '').trim().slice(0, 80),
          in_offer_section: !!cta.closest('.fd-offer__cta-wrap, .dsl-hiw, [data-section]')
        });
      },
      true
    );

    document.addEventListener(
      'click',
      function (e) {
        var scrollCta = e.target.closest('[data-dsl-scroll-to-offer], [data-fd-scroll-to-offer]');
        if (!scrollCta) return;
        track('funnel_scroll_to_offer_clicked', { funnel_page: suffix });
      },
      true
    );
  }

  /**
   * Labor Day offer page (templates/page.labor-day-offer.json). Clicks are read
   * off the DOM here; cart results, offer state and video plays arrive as
   * ld-offer:* DOM events from sections/labor-day-offer.liquid. Every event is
   * prefixed labor_day_ so the page's funnel is one filter in PostHog.
   */
  function initLaborDayOffer() {
    if (templateSuffix() !== 'labor-day-offer') return;

    function offerRoot() {
      return document.querySelector('[data-ld-offer]');
    }

    function spotsLeft() {
      var el = document.querySelector('[data-ld-spots-left]');
      var n = el ? parseInt((el.textContent || '').replace(/[^0-9]/g, ''), 10) : NaN;
      return isNaN(n) ? null : n;
    }

    function offerContext(extra) {
      var root = offerRoot();
      var ctx = {
        tier_key: root ? root.getAttribute('data-tier-key') || null : null,
        offer_state: root ? root.getAttribute('data-ld-state') || 'open' : null,
        spots_left: spotsLeft(),
        spots_pace: root ? Number(root.getAttribute('data-spots-pace')) || 100 : null,
        spots_stock_left: root && root.getAttribute('data-spots-stock-left') ? Number(root.getAttribute('data-spots-stock-left')) : null
      };
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function (key) {
          ctx[key] = extra[key];
        });
      }
      return ctx;
    }

    function ctaText(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el;

        if ((el = t.closest('[data-ld-hero-cta]'))) {
          track('labor_day_hero_cta_clicked', offerContext({ cta_text: ctaText(el) }));
          return;
        }
        if ((el = t.closest('[data-ld-sticky-cta]'))) {
          track('labor_day_sticky_cta_clicked', offerContext({ cta_text: ctaText(el) }));
          return;
        }
        if ((el = t.closest('[data-ld-waitlist-cta]'))) {
          track('labor_day_waitlist_clicked', offerContext({ cta_text: ctaText(el) }));
          return;
        }
        if ((el = t.closest('[data-ld-cta]'))) {
          track('labor_day_checkout_cta_clicked', offerContext({ cta_text: ctaText(el) }));
          return;
        }
        // Capture phase: aria-expanded still holds the state before the toggle.
        if ((el = t.closest('.ld-acc__header, .ld-spot-acc__header'))) {
          if (el.getAttribute('aria-expanded') === 'true') return;
          var title = el.querySelector('.ld-acc__title, .ld-spot-acc__title');
          track('labor_day_accordion_opened', {
            accordion_group: el.classList.contains('ld-spot-acc__header') ? 'spotlight' : 'buy_box',
            question: ctaText(title || el)
          });
        }
      },
      true
    );

    document.addEventListener('ld-offer:added', function (e) {
      track('labor_day_bundle_added', offerContext(e.detail));
    });
    document.addEventListener('ld-offer:add-failed', function (e) {
      track('labor_day_bundle_add_failed', offerContext(e.detail));
    });
    // Fired once per successful add with what the post-add cart read had to repair
    // (duplicates_removed, quantity_fixed); non-zero counts mean a race happened.
    // Order-level offer marker for Recharge renewals (2026-09-12): ok false means the box
    // is in the cart but the renewal marker is not; the Flow still tags the first order.
    document.addEventListener('ld-offer:attribute', function (e) {
      track('labor_day_offer_attribute', offerContext(e.detail));
    });
    document.addEventListener('ld-offer:recheck', function (e) {
      track('labor_day_bundle_recheck', offerContext(e.detail));
    });
    document.addEventListener('ld-offer:video-played', function (e) {
      track('labor_day_video_played', e.detail);
    });

    // Offer closed (countdown passed or spots gone): once per page, whether the
    // state was set before this script loaded or flips while the visitor reads.
    var closedReported = false;
    function reportClosed(state) {
      if (closedReported || state === 'open') return;
      closedReported = true;
      track('labor_day_offer_closed_viewed', offerContext({ offer_state: state }));
    }
    document.addEventListener('ld-offer:state', function (e) {
      reportClosed(e.detail && e.detail.state);
    });
    var rootNow = offerRoot();
    if (rootNow) reportClosed(rootNow.getAttribute('data-ld-state') || 'open');

    // Reached the buy box: half of it on screen, once.
    var box = document.getElementById('offer-box');
    if (box && 'IntersectionObserver' in window) {
      var seen = false;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (seen || !entry.isIntersecting) return;
          seen = true;
          io.disconnect();
          track('labor_day_offer_box_viewed', offerContext());
        });
      }, { threshold: 0.5 });
      io.observe(box);
    }
  }

  /**
   * Brewzle landing page (templates/page.brewzle.json). sections/brewzle-offer.liquid
   * is labor-day-offer.liquid cut down (2026-09-14 brief): same bz-offer:* CustomEvents
   * and data-bz-state mirror ld-offer:* / data-ld-state, tier/price read off
   * data-tier-key / data-bz-price on the offer section root when present. Every
   * section root carries data-bz-section="<name>"; clickable elements carry
   * data-bz-cta="<name>"; barrel cards carry data-bz-card. Events all prefixed
   * brewzle_ so the page is one filter.
   */
  function initBrewzleOffer() {
    if (templateSuffix() !== 'brewzle') return;

    function offerRoot() {
      return document.querySelector('[data-bz-section="offer"]') || document.querySelector('[data-bz-state]');
    }

    function offerContext(extra) {
      var root = offerRoot();
      var ctx = {
        offer_state: root ? root.getAttribute('data-bz-state') || 'open' : null,
        tier_key: root ? root.getAttribute('data-tier-key') || null : null,
        price: root && root.getAttribute('data-bz-price') ? root.getAttribute('data-bz-price') : null
      };
      if (extra && typeof extra === 'object') {
        Object.keys(extra).forEach(function (key) {
          ctx[key] = extra[key];
        });
      }
      return ctx;
    }

    function ctaText(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    var ctaEvents = {
      hero: 'brewzle_hero_cta_clicked',
      lineup: 'brewzle_lineup_cta_clicked',
      pick: 'brewzle_pick_cta_clicked',
      sticky: 'brewzle_sticky_cta_clicked',
      checkout: 'brewzle_checkout_cta_clicked'
    };

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('[data-bz-cta]');
        if (!el) return;
        var event = ctaEvents[el.getAttribute('data-bz-cta')];
        if (event) track(event, offerContext({ cta_text: ctaText(el) }));
      },
      true
    );

    document.addEventListener('bz-offer:added', function (e) {
      track('brewzle_bundle_added', offerContext(e.detail));
    });
    document.addEventListener('bz-offer:add-failed', function (e) {
      track('brewzle_bundle_add_failed', offerContext(e.detail));
    });
    // Renewal marker for Recharge (same pattern as labor_day_offer_attribute,
    // 2026-09-12 entry): ok false means the box is in the cart but the marker
    // attribute write did not land.
    document.addEventListener('bz-offer:attribute', function (e) {
      track('brewzle_offer_attribute', offerContext(e.detail));
    });
    // Fired once per successful add with what the post-add cart read repaired
    // (duplicates_removed, quantity_fixed); non-zero counts mean a race happened.
    document.addEventListener('bz-offer:recheck', function (e) {
      track('brewzle_bundle_recheck', offerContext(e.detail));
    });

    // sections/brewzle-pick.liquid announces this on the play button, bubbling
    // from wherever the video card sits on the page.
    document.addEventListener('bz-pick:video-played', function (e) {
      track('brewzle_video_played', e.detail);
    });
    // sections/brewzle-lineup.liquid announces the tasting-notes flip on a card.
    document.addEventListener('bz-lineup:notes-toggled', function (e) {
      track('brewzle_tasting_notes_toggled', e.detail);
    });

    // The offer uses button-driven accordions. Its local click handler runs before
    // this document listener, so aria-expanded is already the new state here.
    document.addEventListener('click', function (e) {
      var button = e.target && e.target.closest ? e.target.closest('.bz-acc__header') : null;
      if (!button || button.getAttribute('aria-expanded') !== 'true') return;
      if (!button.closest('[data-bz-section="offer"]')) return;
      track('brewzle_accordion_opened', { question: ctaText(button) });
    });

    // Reached the buy box: half of it on screen, once.
    var box = document.getElementById('offer-box');
    if (box && 'IntersectionObserver' in window) {
      var seenBox = false;
      var ioBox = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (seenBox || !entry.isIntersecting) return;
            seenBox = true;
            ioBox.disconnect();
            track('brewzle_offer_box_viewed', offerContext());
          });
        },
        { threshold: 0.5 }
      );
      ioBox.observe(box);
    }

    // Each barrel card, once, half on screen.
    var cards = document.querySelectorAll('[data-bz-card]');
    if (cards.length && 'IntersectionObserver' in window) {
      var seenCards = {};
      var ioCards = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var card = entry.target.getAttribute('data-bz-card');
            if (seenCards[card]) return;
            seenCards[card] = true;
            ioCards.unobserve(entry.target);
            track('brewzle_barrel_card_viewed', { card: card });
          });
        },
        { threshold: 0.5 }
      );
      cards.forEach(function (c) {
        ioCards.observe(c);
      });
    }

    // One brewzle_section_viewed per section, when half of it is on screen.
    var sections = document.querySelectorAll('[data-bz-section]');
    if (sections.length && 'IntersectionObserver' in window) {
      var seenSections = {};
      var ioSections = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var name = entry.target.getAttribute('data-bz-section');
            if (seenSections[name]) return;
            seenSections[name] = true;
            ioSections.unobserve(entry.target);
            track('brewzle_section_viewed', { section: name });
          });
        },
        { threshold: 0.5 }
      );
      sections.forEach(function (s) {
        ioSections.observe(s);
      });
    }
  }

  /**
   * BOF offer page (templates/page.bof.liquid). The offer section marks its root with
   * data-bof-section="offer" and each CTA with data-bof-cta (its placement);
   * assets/bof-offer.js announces the selection and the add as bubbling bof-offer:*
   * CustomEvents, because it can run before this deferred bundle. Every section root
   * carries data-bof-section and reports once when half of it is on screen; the shared
   * community band (sections/quiz-community.liquid, #quiz-community) has no attribute of
   * its own and reports as "community". Events are prefixed bof_ so the page is one filter.
   */
  function initBofOffer() {
    if (templateSuffix() !== 'bof') return;

    function ctaText(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    document.addEventListener(
      'click',
      function (e) {
        var el = e.target && e.target.closest ? e.target.closest('[data-bof-cta]') : null;
        if (!el) return;
        var root = el.closest('[data-bof-section="offer"]');
        track('bof_cta_clicked', {
          placement: el.getAttribute('data-bof-cta') || null,
          tier: el.getAttribute('data-bof-tier') || (root && root.getAttribute('data-bof-tier')) || null,
          cta_text: ctaText(el)
        });
      },
      true
    );

    // Section events from assets/bof-offer.js. That file loads async and can announce before
    // this one runs, so it also keeps every event on window.__bofOfferQueue: replayed here
    // once, then the listeners take over (nothing is counted twice).
    //   attributes_failed: the box is in the cart but the milestone attribute write did not
    //     land (the renewal marker Recharge reads); same idea as brewzle_offer_attribute.
    //   plan_mismatch: the card showed one variant or plan and /api/tiers named another; the
    //     tap fails closed and is reported, this is the analytics record.
    //   recheck_failed: a lost cart read after a good add; the box is in the cart, nothing paged.
    var BOF_EVENTS = {
      selected: 'bof_offer_selected',
      added: 'bof_bundle_added',
      failed: 'bof_bundle_add_failed',
      attributes_failed: 'bof_offer_attribute_failed',
      plan_mismatch: 'bof_offer_plan_mismatch',
      recheck_failed: 'bof_bundle_recheck_failed',
      sticky_shown: 'bof_sticky_shown',
      accordion_opened: 'bof_accordion_opened',
      video_played: 'bof_video_played',
      gallery_viewed: 'bof_gallery_viewed',
      rating_clicked: 'bof_rating_clicked'
    };
    (window.__bofOfferQueue || []).forEach(function (item) {
      if (item && BOF_EVENTS[item.state]) track(BOF_EVENTS[item.state], item.detail);
    });
    Object.keys(BOF_EVENTS).forEach(function (state) {
      document.addEventListener('bof-offer:' + state, function (e) {
        track(BOF_EVENTS[state], e.detail);
      });
    });
    // The FAQ (sections/bof-faq.liquid) opens in place; toggle does not bubble, so it is
    // read in the capture phase.
    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d || !d.matches || !d.matches('details[data-bof-faq]') || !d.open) return;
        var q = d.querySelector('summary');
        track('bof_faq_opened', {
          question: q ? (q.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120) : null,
          position: Number(d.getAttribute('data-bof-faq')) || null
        });
      },
      true
    );
    // The community band's rows are role="button" headers that the section's own script
    // opens on click (Enter and Space click too). This bubbling listener runs after that
    // script, so aria-expanded already says whether the tap opened the row.
    document.addEventListener('click', function (e) {
      var header = e.target && e.target.closest ? e.target.closest('#quiz-community .quiz-community__list-header') : null;
      if (!header || header.getAttribute('aria-expanded') !== 'true') return;
      var item = header.closest('[data-accordion-item]');
      var title = header.querySelector('.quiz-community__list-title');
      track('bof_community_item_opened', {
        item: title ? (title.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120) : null,
        position: item && item.parentNode ? Array.prototype.indexOf.call(item.parentNode.children, item) + 1 : null
      });
    });

    // A box the section could not price (product or plan missing) renders no card; the
    // section names it on its root, and this is the record that it happened.
    var offerRoot = document.querySelector('[data-bof-section="offer"][data-bof-missing]');
    if (offerRoot) {
      track('bof_offer_missing', { tiers: (offerRoot.getAttribute('data-bof-missing') || '').split(/\s+/).filter(Boolean) });
    }

    // Viewed at half its height or half the screen, whichever is less: the buy box and
    // the reviews are taller than two phone screens and never reach half their own height.
    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-bof-section]'));
    var community = document.getElementById('quiz-community');
    if (community && !community.hasAttribute('data-bof-section')) sections.push(community);
    if (sections.length && 'IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var screen = window.innerHeight || document.documentElement.clientHeight || 0;
            var half = entry.intersectionRatio >= 0.5 || (screen > 0 && entry.intersectionRect.height >= screen / 2);
            if (!half) return;
            var name = entry.target.getAttribute('data-bof-section') || 'community';
            if (seen[name]) return;
            seen[name] = true;
            io.unobserve(entry.target);
            track('bof_section_viewed', { section: name });
          });
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5] }
      );
      sections.forEach(function (s) {
        io.observe(s);
      });
    }
  }

  /**
   * How It Works and About Us (templates/page.how-it-works.liquid, page.about-us.liquid).
   * Every section root carries data-wls-section and reports once at half its height or half
   * the screen; links and buttons carry data-wls-cta (their placement, plus data-wls-tier on
   * the box cards); assets/wls-pages.js announces the video pop-up, the box switch and the
   * swipe rows as bubbling wls:* CustomEvents. Events are prefixed hiw_ or about_ so each
   * page is one filter. The private selection cards report through initProductCards
   * (surface how_it_works_selections / about_us_selections).
   */
  function initStoryPages() {
    var suffix = templateSuffix();
    var prefix = suffix === 'how-it-works' ? 'hiw_' : suffix === 'about-us' ? 'about_' : '';
    if (!prefix) return;

    function text(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 120);
    }

    document.addEventListener(
      'click',
      function (e) {
        var el = e.target && e.target.closest ? e.target.closest('[data-wls-cta]') : null;
        if (!el) return;
        track(prefix + 'cta_clicked', {
          placement: el.getAttribute('data-wls-cta') || null,
          tier: el.getAttribute('data-wls-tier') || null,
          cta_text: text(el).slice(0, 80),
          href: el.getAttribute('href') || null
        });
      },
      true
    );

    var WLS_EVENTS = {
      video_opened: 'video_opened',
      video_closed: 'video_closed',
      tier_selected: 'tier_selected',
      carousel_moved: 'carousel_moved'
    };
    Object.keys(WLS_EVENTS).forEach(function (name) {
      document.addEventListener('wls:' + name, function (e) {
        track(prefix + WLS_EVENTS[name], e.detail || {});
      });
    });

    document.addEventListener(
      'toggle',
      function (e) {
        var d = e.target;
        if (!d || !d.matches || !d.matches('details[data-wls-faq]') || !d.open) return;
        var q = d.querySelector('summary');
        track(prefix + 'faq_opened', {
          question: q ? text(q) : null,
          position: Number(d.getAttribute('data-wls-faq')) || null
        });
      },
      true
    );

    var tiers = document.querySelector('[data-wls-section="tiers"][data-wls-missing]');
    if (tiers) {
      track(prefix + 'tiers_missing', { tiers: (tiers.getAttribute('data-wls-missing') || '').split(/\s+/).filter(Boolean) });
    }

    var sections = Array.prototype.slice.call(document.querySelectorAll('[data-wls-section]'));
    if (sections.length && 'IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var screen = window.innerHeight || document.documentElement.clientHeight || 0;
            var half = entry.intersectionRatio >= 0.5 || (screen > 0 && entry.intersectionRect.height >= screen / 2);
            if (!half) return;
            var name = entry.target.getAttribute('data-wls-section');
            if (seen[name]) return;
            seen[name] = true;
            io.unobserve(entry.target);
            track(prefix + 'section_viewed', { section: name });
          });
        },
        { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5] }
      );
      sections.forEach(function (s) {
        io.observe(s);
      });
    }
  }

  /**
   * Homepage rework (templates/index.json since 2026-09-18). Every section marks
   * its root with data-hp-section and its controls with data-hp-cta, so clicks
   * are read off the DOM here and each section reports once when half of it is
   * on screen. Events are prefixed homepage_ so the page is one filter.
   */
  function initHomepageRework() {
    if (templateSuffix() !== 'index') return;

    function text(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    function sectionOf(el) {
      var root = el.closest('[data-hp-section]');
      return root ? root.getAttribute('data-hp-section') : null;
    }

    var ctaEvents = {
      'hero-cta': 'homepage_hero_cta_clicked',
      'hero-shop-link': 'homepage_hero_shop_link_clicked',
      'bottles-tab': 'homepage_bottle_tab_clicked',
      'product-card': 'homepage_product_card_clicked',
      'bottles-prev': 'homepage_carousel_scrolled',
      'bottles-next': 'homepage_carousel_scrolled',
      'category': 'homepage_category_clicked',
      'intro-cta': 'homepage_intro_cta_clicked',
      'tier-cta': 'homepage_tier_cta_clicked',
      'member-tile': 'homepage_member_tile_clicked',
      'tiers-prev': 'homepage_carousel_scrolled',
      'tiers-next': 'homepage_carousel_scrolled',
      'members-prev': 'homepage_carousel_scrolled',
      'members-next': 'homepage_carousel_scrolled',
      'members-load-more': 'homepage_members_load_more_clicked',
      'reviews-prev': 'homepage_carousel_scrolled',
      'reviews-next': 'homepage_carousel_scrolled'
    };

    document.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('[data-hp-cta]');
        var cta = el ? el.getAttribute('data-hp-cta') : null;
        if (!el) {
          // The bottle shop renders the shared card (data-wl-cta) since 2026-09-11; keep the
          // homepage event name alive until Bhuvi retires it in favour of product_card_clicked.
          var cardLink = t.closest('[data-wl-cta="product-card"]');
          if (!cardLink || !cardLink.closest('[data-hp-section]')) return;
          el = cardLink;
          cta = 'product-card';
        }
        var event = ctaEvents[cta] || 'homepage_cta_clicked';
        var props = { cta: cta, cta_text: text(el), section: sectionOf(el) };
        if (el.getAttribute('data-hp-tier')) props.tier = el.getAttribute('data-hp-tier');
        if (el.getAttribute('data-hp-product') || el.getAttribute('data-wl-product')) props.product_handle = el.getAttribute('data-hp-product') || el.getAttribute('data-wl-product');
        if (el.getAttribute('data-hp-category')) props.category = el.getAttribute('data-hp-category');
        if (el.getAttribute('data-hp-tab')) props.tab = el.getAttribute('data-hp-tab');
        if (el.getAttribute('data-hp-network')) props.network = el.getAttribute('data-hp-network');
        if (cta.indexOf('-prev') !== -1 || cta.indexOf('-next') !== -1) {
          props.direction = cta.indexOf('-prev') !== -1 ? 'prev' : 'next';
        }
        track(event, props);
      },
      true
    );

    // hp-tiers:checkout from sections/hp-tiers.liquid: the tier CTA builds the box in the
    // cart and goes to checkout; the section announces each step and this file names it.
    var tierCheckoutEvents = {
      started: 'homepage_tier_checkout_started',
      added: 'homepage_tier_bundle_added',
      failed: 'homepage_tier_bundle_add_failed',
      attributes_failed: 'homepage_tier_attributes_failed'
    };
    document.addEventListener('hp-tiers:checkout', function (e) {
      var d = (e && e.detail) || {};
      var name = tierCheckoutEvents[d.state];
      if (!name) return;
      var props = { tier: d.tier, tier_key: d.tier_key, bundle_id: d.bundle_id };
      if (d.item_count != null) props.item_count = d.item_count;
      if (d.kept_bundle_id) { props.kept_bundle_id = d.kept_bundle_id; props.own_bundle_kept = d.own_bundle_kept; props.duplicates_removed = d.duplicates_removed; props.quantity_fixed = d.quantity_fixed; }
      if (d.stage) props.stage = d.stage;
      if (d.error_message) props.error_message = String(d.error_message).slice(0, 200);
      track(name, props);
    });

    // One homepage_section_viewed per section, when half of it is on screen.
    var sections = document.querySelectorAll('[data-hp-section]');
    if (sections.length && 'IntersectionObserver' in window) {
      var seen = {};
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var name = entry.target.getAttribute('data-hp-section');
            if (seen[name]) return;
            seen[name] = true;
            io.unobserve(entry.target);
            track('homepage_section_viewed', { section: name });
          });
        },
        { threshold: 0.5 }
      );
      sections.forEach(function (s) {
        io.observe(s);
      });
    }
  }

  /** DOM fallback if React bundle does not emit custom events (older builds). */
  /**
   * Global header and footer (sections/wl-header.liquid, sections/wl-footer.liquid, in the
   * header and footer groups on every page). Controls carry data-wl-cta; clicks are read off
   * the DOM here and named nav_* or footer_* so one filter covers the chrome on every template.
   * The header announces wl-nav:panel-open when its Bottle Shop panel opens (hover or tap), and
   * assets/wl-nav.js announces the phone menu's panel and accordions, the account dropdown and
   * search submits as wl-nav:* events.
   */
  function initGlobalChrome() {
    function text(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }

    var ctaEvents = {
      'nav-link': 'nav_link_clicked',
      'nav-logo': 'nav_logo_clicked',
      'nav-panel': 'nav_panel_title_clicked',
      'nav-panel-link': 'nav_panel_link_clicked',
      'nav-panel-card': 'nav_panel_card_clicked',
      'nav-menu-open': 'nav_menu_drawer_opened',
      'nav-cart': 'nav_cart_opened',
      'nav-search': 'nav_search_opened',
      'nav-account': 'nav_account_clicked',
      'nav-account-link': 'nav_account_link_clicked',
      'nav-drawer-link': 'nav_drawer_link_clicked',
      'nav-drawer-card': 'nav_drawer_card_clicked',
      'nav-drawer-back': 'nav_drawer_back_clicked',
      'nav-search-recent': 'nav_search_recent_clicked',
      'nav-search-popular': 'nav_search_popular_clicked',
      'nav-search-clear': 'nav_search_recent_cleared',
      'nav-search-suggestion': 'nav_search_suggestion_clicked',
      'nav-search-product': 'nav_search_product_clicked',
      'nav-search-all': 'nav_search_all_clicked',
      'footer-link': 'footer_link_clicked',
      'footer-social': 'footer_social_clicked',
      'footer-logo': 'footer_logo_clicked',
      'footer-contact': 'footer_contact_clicked'
    };

    // On window, capture phase: the theme's own document-level capture listener stops the cart
    // and search icon clicks before a later document listener sees them, and this file loads after
    // theme.js, so a document listener here only sometimes ran. Window capture always runs first.
    window.addEventListener(
      'click',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var el = t.closest('[data-wl-cta]');
        if (!el) return;
        var cta = el.getAttribute('data-wl-cta');
        var event = ctaEvents[cta];
        if (!event) return;
        var props = { cta: cta, cta_text: text(el), template: templateSuffix() || (window.Shopify && Shopify.template) || null };
        var href = el.getAttribute('href');
        if (href) props.href = href;
        if (el.getAttribute('data-wl-column')) props.column = el.getAttribute('data-wl-column');
        if (el.getAttribute('data-wl-network')) props.network = el.getAttribute('data-wl-network');
        if (el.getAttribute('data-wl-channel')) props.channel = el.getAttribute('data-wl-channel');
        if (el.getAttribute('data-wl-link')) props.link = el.getAttribute('data-wl-link');
        if (el.getAttribute('data-wl-surface')) props.surface = el.getAttribute('data-wl-surface');
        track(event, props);
      },
      true
    );

    document.addEventListener('wl-nav:panel-open', function (e) {
      var d = (e && e.detail) || {};
      track('nav_panel_opened', { panel: d.panel || null });
    });
    document.addEventListener('wl-nav:drawer-panel', function (e) {
      var d = (e && e.detail) || {};
      track('nav_drawer_panel_opened', { panel: d.panel || null });
    });
    document.addEventListener('wl-nav:drawer-accordion', function (e) {
      var d = (e && e.detail) || {};
      track('nav_drawer_accordion_opened', { column: d.column || null });
    });
    document.addEventListener('wl-nav:account-open', function (e) {
      var d = (e && e.detail) || {};
      track('nav_account_menu_opened', { surface: d.surface || null, state: d.state || null, trigger: d.trigger || null });
    });
    document.addEventListener('wl-nav:search-submit', function (e) {
      var d = (e && e.detail) || {};
      track('nav_search_submitted', { query: d.query || null, query_length: d.query_length || 0, surface: d.surface || null });
    });
  }

  function initQuizQuestionsDomFallback() {
    if (templateSuffix() !== 'quiz-questions') return;

    var reported = { started: false, email: false };
    var lastQuestionKey = '';

    function poll() {
      var quiz = document.querySelector('.quiz');
      if (!quiz) return;

      if (!reported.started && document.querySelector('.quiz__question')) {
        reported.started = true;
        track('quiz_started', { source: 'dom_fallback' });
      }

      var qEl = document.querySelector('.quiz__question');
      if (qEl) {
        var qText = (qEl.textContent || '').trim().slice(0, 200);
        if (qText && qText !== lastQuestionKey) {
          lastQuestionKey = qText;
          var counter = document.querySelector('.quiz__counter');
          track('quiz_question_viewed', {
            question_text: qText,
            counter: counter ? (counter.textContent || '').trim() : null,
            source: 'dom_fallback'
          });
        }
      }

      if (!reported.email && document.querySelector('.quiz__email-section')) {
        reported.email = true;
        track('quiz_email_step_viewed', { source: 'dom_fallback' });
      }
    }

    document.addEventListener(
      'click',
      function (e) {
        var opt = e.target.closest('.quiz__option');
        if (!opt) return;
        track('quiz_answer_selected', {
          answer_label: (opt.querySelector('.quiz__option-label') || opt).textContent.trim().slice(0, 120),
          source: 'dom_fallback'
        });
      },
      true
    );

    setInterval(poll, 800);
    poll();
  }

  function initRetakeLink() {
    document.addEventListener(
      'click',
      function (e) {
        var link = e.target.closest('a[href*="quiz-questions"][href*="retake"]');
        if (!link) return;
        track('quiz_retake_clicked', { href: link.getAttribute('href') });
      },
      true
    );
  }

  // Collection page rework (sections/wl-collection.liquid, 2026-09-11). The section announces
  // CustomEvents and marks its links with data-wl-cta; the names live here.
  function initCollection() {
    var root = document.querySelector('[data-wl-col]');
    if (!root) return;

    function text(el) {
      return (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80);
    }
    function collectionHandle() {
      var m = window.location.pathname.match(/\/collections\/([^\/?#]+)/);
      return m ? m[1] : null;
    }
    function base(extra) {
      var props = { surface: 'collection', collection: collectionHandle(), template: templateSuffix() || null };
      for (var k in extra) if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
      return props;
    }

    var ctaEvents = {
      'product-card': 'product_card_clicked',
      'hunting-tile': 'collection_hunting_tile_clicked'
    };

    root.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el = t.closest('[data-wl-cta]');
      if (!el || !root.contains(el)) return;
      var cta = el.getAttribute('data-wl-cta');
      if (cta === 'add-to-cart') return; // captured on wl-pcard:add, once the add succeeded
      if (cta === 'locked') return; // captured by initProductCardLocks(), same event everywhere
      var event = ctaEvents[cta] || 'collection_cta_clicked';
      var props = base({ cta: cta, cta_text: text(el) });
      if (el.getAttribute('data-wl-product')) props.product_handle = el.getAttribute('data-wl-product');
      var card = el.closest('[data-wl-pcard]');
      if (card && card.getAttribute('data-wl-price')) props.price = Number(card.getAttribute('data-wl-price')) || null;
      if (card && card.getAttribute('data-wl-variant')) props.variant_id = Number(card.getAttribute('data-wl-variant')) || null;
      track(event, props);
    });

    root.addEventListener('wl-pcard:add', function (e) {
      track('product_card_add_to_cart', base(e.detail || {}));
    });
    root.addEventListener('wl-pcard:add-failed', function (e) {
      track('product_card_add_to_cart_failed', base(e.detail || {}));
    });
    root.addEventListener('wl-collection:filter', function (e) {
      track('collection_filter_applied', base(e.detail || {}));
    });
    root.addEventListener('wl-collection:sort', function (e) {
      track('collection_sort_changed', base(e.detail || {}));
    });
    root.addEventListener('wl-collection:page', function (e) {
      track('collection_page_changed', base(e.detail || {}));
    });
  }

  // Shared product card (snippets/wl-product-card.liquid and its React twin), on every surface
  // except the collection grid, which initCollection covers. surface comes from the card.
  function initProductCards() {
    function surfaceOf(el) {
      var card = el.closest('[data-wl-pcard]');
      return card ? card.getAttribute('data-wl-surface') : null;
    }
    function inCollection(el) { return !!el.closest('[data-wl-col]'); }
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el = t.closest('[data-wl-cta="product-card"]');
      if (!el || inCollection(el)) return;
      var card = el.closest('[data-wl-pcard]');
      if (!card) return;
      track('product_card_clicked', {
        surface: surfaceOf(el),
        product_handle: el.getAttribute('data-wl-product'),
        price: Number(card.getAttribute('data-wl-price')) || null,
        variant_id: Number(card.getAttribute('data-wl-variant')) || null,
        cta_text: (el.textContent || '').replace(/\s+/g, ' ').trim().slice(0, 80),
        template: templateSuffix() || (window.Shopify && Shopify.template) || null
      });
    });
    document.addEventListener('wl-pcard:add', function (e) {
      if (e.target && e.target.closest && inCollection(e.target)) return;
      track('product_card_add_to_cart', e.detail || {});
    });
    document.addEventListener('wl-pcard:add-failed', function (e) {
      if (e.target && e.target.closest && inCollection(e.target)) return;
      track('product_card_add_to_cart_failed', e.detail || {});
    });
  }

  // Members-only lock CTA, on every card that renders one: the shared wl-pcard card
  // (collection rework, PDP carousels, homepage bottle shop) and the legacy
  // snippets/product-card.liquid collection card, which carries no [data-wl-pcard].
  // One listener, one event, so initCollection() skips 'locked' rather than also firing
  // its generic collection_cta_clicked for the same click. Capture phase: the cart drawer's
  // panel stops click propagation at React's root, so a bubbling document listener never saw
  // the drawer's lock (surface cart_drawer).
  function initProductCardLocks() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var el = t.closest('[data-wl-cta="locked"]');
      if (!el) return;
      var card = el.closest('[data-wl-pcard]');
      // The legacy card carries no surface attribute; a collection URL is the only place it
      // renders a lock today (search and the featured rails would read 'other').
      var surface = card ? card.getAttribute('data-wl-surface') : (el.closest('[data-wl-col]') || location.pathname.indexOf('/collections/') === 0 ? 'collection' : 'other');
      track('product_card_lock_clicked', {
        surface: surface,
        product_handle: el.getAttribute('data-wl-product'),
        signed_in: !!(window.__CART_DRAWER_CONFIG__ && window.__CART_DRAWER_CONFIG__.customerId)
      });
    }, true);
  }

  // Help & FAQ page (sections/help-faq.liquid, 2026-09-25) and the Subject / Order topic /
  // Order number fields on the contact forms (snippets/contact-topic-fields.liquid: the Get
  // In Touch page and the FAQ help form). Both announce CustomEvents; the names live here.
  // Only the listed keys go out: a chosen subject and order topic, field names, never a
  // value a shopper typed (order number, email, name, phone, message).
  function initHelpFaq() {
    function props(detail, keys) {
      var d = detail || {};
      var out = { template: templateSuffix() || (window.Shopify && Shopify.template) || null };
      keys.forEach(function (key) {
        if (d[key] !== undefined) out[key] = d[key];
      });
      return out;
    }
    document.addEventListener('wl-faq:group-open', function (e) {
      track('faq_group_opened', props(e.detail, ['surface', 'group', 'group_index', 'opened_by']));
    });
    document.addEventListener('wl-faq:question-open', function (e) {
      track('faq_question_opened', props(e.detail, ['surface', 'group', 'question', 'question_index', 'opened_by']));
    });
    document.addEventListener('wl-contact:submit', function (e) {
      track('contact_form_submitted', props(e.detail, ['surface', 'subject', 'order_topic']));
    });
    document.addEventListener('wl-contact:invalid', function (e) {
      track('contact_form_invalid', props(e.detail, ['surface', 'fields']));
    });
  }

  function initAll() {
    initQuizNavSource();
    // initFunnelPageView() removed 2026-08-21 — funnel_page_viewed was firing from
    // here AND from the loaded() callback in snippets/analytics-posthog.liquid, on
    // every funnel page. The snippet's version now carries funnel_step as well, so
    // this one is a pure duplicate. Left defined, uncalled.
    // initFunnelPageView();
    initQuizLandingMilestoneUser();
    initQuizLandingClicks();
    initTasteProfileObservers();
    initTasteProfileClose();
    initDragonSlayerAndFatherDay();
    initLaborDayOffer();
    initBrewzleOffer();
    initBofOffer();
    initStoryPages();
    initHomepageRework();
    initGlobalChrome();
    initCollection();
    initProductCards();
    initProductCardLocks();
    initHelpFaq();
    // initQuizQuestionsDomFallback() removed 2026-08-20.
    //
    // It polled the DOM and fired quiz_started / quiz_question_viewed /
    // quiz_email_step_viewed with source:'dom_fallback' while the React app fired
    // the quiz_v2_* versions of the same moments — the double-firing Bhuvi asked
    // to clean up (quiz_started 58,699 vs quiz_v2_started 59,021 over 30 days).
    // The React app now emits those names itself, with real question ids and
    // indexes instead of scraped text, so the fallback would duplicate rather
    // than back up. The function is left in place, uncalled, in case the React
    // path ever needs a stand-in again.
    initRetakeLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
